<template>
    <div class="game-info-tool-tip" id="game-info-tool-tip" :style="{ left: `${position.x}px`, top: `${position.y}px` }"
        v-show="show">
        <div v-if="type === 'normal'" class="tool-tip-normal">
            <div class="tool-tip-normal-title tool-tip-title">
                <p>{{ toolTipData.title }}</p>
            </div>
            <div class="tool-tip-normal-desc" v-dragscroll>
                <span v-html="toolTipData.desc"></span>
            </div>
        </div>
        <div v-if="type === 'skill'" class="tool-tip-skill">
            <div class="tool-tip-skill-title tool-tip-title">
                <p>獲得技能</p>
            </div>
            <div class="tool-tip-skill-content">
                <div class="skill-row1">{{ toolTipData.skillName }}</div>
                <div class="skill-row2">
                    <div class="skill-type">類型: {{ toolTipData.skillType }}</div>
                    <div class="skill-expend">消耗: {{ toolTipData.skillSpend }}</div>
                </div>
                <div class="skill-row3">
                    {{ toolTipData.hasWeapon ? `武器:${toolTipData.weaponType}` : `冷卻:${toolTipData.skillCd}`  }}
                </div>
            </div>
            <div v-if="toolTipData.skillDesc && !isNull(toolTipData.skillDesc)" class="tool-tip-skill-desc"
                v-html="toolTipData.skillDesc"></div>
            <div class="tool-tip-skill-title tool-tip-title" v-if="toolTipData.powerDesc">
                <p>{{ toolTipData.title }}</p>
            </div>
            <div class="tool-tip-skill-powerdesc" v-if="toolTipData.powerDesc">
                <span v-html="toolTipData.powerDesc"></span>
            </div>
        </div>
    </div>
</template>

<script>
import dragscroll from '../../directive/dragable.js'
export default {
    directives: {
        dragscroll
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'normal'
        },
        position: {
            type: Object,
            default: () => {
                return {
                    x: 0,
                    y: 0
                }
            }
        },
        toolTipData: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    methods: {
        //判断是否为空字符串并且去除空格
        isNull(str) {
            if (str === null || str === undefined || str === '') {
                return true
            } else {
                return false
            }
        }
    }
}

</script>

<style lang="scss" scoped>
.ipad .game-info-tool-tip {
    transform: translateY(-50%);
}

.game-info-tool-tip {
    position: absolute;
    width: 3.59rem;
    background-color: #474951;
    border: .01rem solid #696b71;
    box-shadow: 0 .02rem .04rem #000;
    padding: .04rem .02rem;
    max-height: 4rem;

    .tool-tip-normal {
        position: relative;
        font-size: .2rem;
        color: white;
        box-sizing: border-box;

        &-title {
            position: relative;
            margin: 0 auto;
            margin-bottom: .1rem;

            p {
                padding-left: .15rem;
                font-weight: bold;
            }

            p::before {
                content: '';
                width: .04rem;
                height: 80%;
                background-color: #fff;
                position: absolute;
                left: .04rem;
                top: 50%;
                transform: translateY(-50%);
            }
        }

        &-desc {
            position: relative;
            width: 100%;
            font-size: .2rem;
            padding: 0rem .1rem .17rem .28rem;
            box-sizing: border-box;
            max-height: 3rem;
            overflow-y: auto;
        }

        /deep/.tool-tip-normal-desc>span {
            display: list-item;
            list-style: square;
        }
    }

    .tool-tip-skill {
        position: relative;
        font-size: .2rem;
        color: white;
        box-sizing: border-box;

        &-title {
            position: relative;
            margin: 0 auto;

            p {
                padding-left: .15rem;
                font-weight: bold;
            }

            p::before {
                content: '';
                width: .04rem;
                height: 80%;
                background-color: #fff;
                position: absolute;
                left: .04rem;
                top: 50%;
                transform: translateY(-50%);
            }
        }

        &-content {
            padding: .1rem .2rem;

            .skill-row1 {
                font-size: .2rem;
                font-weight: bold;
            }

            .skill-row2 {
                display: flex;
                position: relative;

                .skill-type,
                .skill-expend {
                    width: 50%;
                    text-align: left;
                }
            }
        }

        &-desc {
            padding: .1rem .2rem;
            background-color: #373942;
            margin-bottom: .1rem;
        }

        &-powerdesc {
            position: relative;
            width: 100%;
            font-size: .2rem;
            padding: .17rem .28rem;
            box-sizing: border-box;
        }

        /deep/.tool-tip-skill-powerdesc>span {
            display: list-item;
            list-style: square;
        }
    }
}</style>
